// src/api/axiosConfig.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:3003",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

const showLoader = () => {
  const loader = document.getElementById("loader");
  if (loader) loader.style.display = "flex";
};

const hideLoader = () => {
  const loader = document.getElementById("loader");
  if (loader) loader.style.display = "none";
};

axiosInstance.interceptors.request.use(
  (config) => {
    showLoader();

    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    hideLoader();
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    hideLoader();
    return response;
  },
  (error) => {
    hideLoader();
    if (error.response && error.response.status === 401) {
      localStorage?.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
